import React from 'react';
import { Button, Modal } from 'AWS-UI-Components-React';

export class DownloadDataWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      download: '',
    };
  }

  onCancel = () => {
    this.props.onCancel();
  };

  onColumnDownload = () => {
    this.setState({ download: 'columns' });
    this.props.onSubmit(this.state.download);
  };

  onRowDownload = () => {
    this.setState({ download: 'rows' });
    this.props.onSubmit(this.state.download);
  };

  render() {
    return (
      <Modal
        visible={true}
        size="medium"
        header={'Download Data'}
        expandToFit={true}
        onDismiss={this.onCancel}
        footer={
          <span className="awsui-util-f-r">
            <Button text="Cancel" onClick={this.onCancel} />
            <Button variant="primary" text="Row-wise Comparison" onClick={this.onRowDownload}/>
            <Button variant="primary" text="Side by side Comparison" onClick={this.onColumnDownload}/>
          </span>
        }
        content={
          <div>
            <h4 className="awsui-util-t-c">DOWNLOAD REPORT AS<br/><br/></h4>
          </div>
        }
      />
    );
  }
}

export default DownloadDataWindow;


// WEBPACK FOOTER //
// ./src/components/content/download_data_window.jsx